/*
 * @providesModule ChatStore
 * 
 */

import ClientPropertyConstants from 'ClientPropertyConstants';
import RESTStore from 'RESTStore';
import {ChatSettings} from 'ChatManager';

class ChatStore {
  initializeChatSettings(useCache: boolean = false, completion: (result: ChatSettings | null, error: Error | string | null) => void, shouldRetry: boolean = false) {
    if (!ClientPropertyConstants.getIsPlayerChatEnabled()) {
      completion(null, 'chat is disabled');
      return;
    }

    const getResponse = useCache ? RESTStore.getAnyResponse.bind(RESTStore) : RESTStore.getServerResponse.bind(RESTStore);

    getResponse('settings/chat', null, shouldRetry, (payload: ChatSettings, error: Error | null) => {
      if (!payload) {
        console.debug('Chat settings error: ' + JSON.stringify(error));
      }
      completion(payload, error);
    });
  }
}

export default new ChatStore();
